// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","caption":"fonts__caption____HpZ4e","oldColorViolet":"#652c91","colorPrimaryOrange":"#e16e46","orderedItem":"ordered-item__orderedItem____1bOqR","orderedItemLabel":"ordered-item__orderedItemLabel____2uq6e","isDragging":"ordered-item__isDragging____2LnQL","outlined":"ordered-item__outlined____9WQsG","hintText":"ordered-item__hintText____1Ot6Z fonts__caption____HpZ4e"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/ordered-item/ordered-item.css
// module id = 611
// module chunks = 0